import { styled } from '@mui/material';

import { useScenarioDetailsContext } from '@app-velocity/modules/scenarios';

import { ReviewsData } from '../ReviewsData';
import { SetUp } from './components/SetUp';

const Section = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

export const HumanTestingSection = () => {
  const { scenario } = useScenarioDetailsContext();

  return (
    <Section>
      {!scenario.finalTriggerElement ? <SetUp /> : <ReviewsData />}
    </Section>
  );
};
